module.exports = __webpack_public_path__ + "static/img/user-pic.23a3129c.png";